import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Error from '@iarcpsu/emanufac-components/src/components/Error/Error';
import { AvailableModuleForm } from '@iarcpsu/emanufac-components/src/components/Forms';
import Loading from '@iarcpsu/emanufac-components/src/components/Loading';
import { ViewTitle } from '@iarcpsu/emanufac-components/src/components/ViewTitle';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

import * as actions from '../../redux/actions';

const ModuleSelectors = ({ title, subtitle }) => {
  const dispatch = useDispatch();
  const availableModule = useSelector((state) => state.availableModule);

  const { handleSubmit, control } = useForm();

  useEffect(() => {
    dispatch(actions.availableModuleAll());
    return () => {};
  }, []);

  const onSubmit = async (data, event) => {
    try {
      console.log('DATA', data);
      event.preventDefault();
      await dispatch(actions.availableModulePut(availableModule._id, data));
      alert('สำเร็จ');
      await dispatch(actions.availableModuleAll());
    } catch (error) {
      console.error(error);
    }
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const renderForm = () => (
    <form onSubmit={handleSubmit(onSubmit)}>
      <AvailableModuleForm
        Controller={Controller}
        control={control}
        availableModule={availableModule}
      />
      <div className="flex flex-row justify-end gap-1 py-4">
        <Button variant="contained" type="submit">
          บันทึก
        </Button>
      </div>
    </form>
  );

  if (availableModule.isLoading) {
    return <Loading />;
  }
  if (!availableModule.isLoading && availableModule.isCompleted) {
    return (
      <div>
        {renderTitle()}
        {renderForm()}
      </div>
    );
  }

  return <Error />;
};

ModuleSelectors.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ModuleSelectors.defaultProps = {
  title: '',
  subtitle: '',
};

export default ModuleSelectors;
